<div class="s__detect-summary">
  <div class="s__detect-summary__grid">
    @for (item of items(); track item.label) {
      <div class="s__detect-summary__item" [class.s__detect-summary__item--highlight]="item.highlight">
        <span class="s__detect-summary__label">{{ item.label }}</span>
        @if (item.href) {
          <a class="s__detect-summary__value s__detect-summary__value--link" [href]="item.href">{{ item.value }}</a>
        } @else {
          <span class="s__detect-summary__value">{{ item.value }}</span>
        }
      </div>
    }
  </div>
</div>
